// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useSnackbar } from 'notistack';
import React from 'react';
import { Box, Card, Switch, Typography } from '@mui/material';
import { useLocalStorage } from '../../contexts/LocalStorageContext';

export const NetworkPolling: React.FC = () => {
  const { localStorageState, setLocalStorageState } = useLocalStorage();
  const { enqueueSnackbar } = useSnackbar();

  const onToggle = () => {
    setLocalStorageState('pollingEnabled', `${!localStorageState?.pollingEnabled}`);
    enqueueSnackbar(`Polling ${!localStorageState?.pollingEnabled ? 'enabled' : 'disabled'}`);
  };
  const { pollingEnabled } = localStorageState;
  return (
    <Card
      sx={{ mb: 1, width: '50%', p: 1, display: 'flex', alignItems: 'center' }}
      variant="outlined"
    >
      <Box>
        <Typography fontWeight="bold">Network Polling</Typography>
        <Typography variant="body2">
          If toggled off, manual refreshing will be required to see updated data.
        </Typography>
      </Box>
      <Switch sx={{ ml: 'auto' }} checked={pollingEnabled} onChange={onToggle} />
    </Card>
  );
};
